import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import StaffRecipientsPanel from './StaffRecipientsPanel';
import SupportRoutingPanel from './SupportRoutingPanel';

const StaffAlerts = () => (
    <Container fluid className="py-4">
        <Row className="mb-4">
            <Col>
                <h2 className="mb-1">Staff Alerts</h2>
                <p className="text-muted mb-0">
                    Choose which team member receives which internal WhatsApp alert, so delivery, support and sales requests reach the right people.
                </p>
            </Col>
        </Row>
        <Row>
            <Col xs={12} lg={8} xl={6} className="mb-4">
                <StaffRecipientsPanel />
            </Col>
            <Col xs={12} lg={8} xl={6} className="mb-4">
                <SupportRoutingPanel />
            </Col>
        </Row>
    </Container>
);

export default StaffAlerts;
